export default __webpack_public_path__ + "static/media/landin-blockimg9.9beaf246.png";